import { render, staticRenderFns } from "./StartseiteLeads.vue?vue&type=template&id=27db5aa5"
import script from "./StartseiteLeads.vue?vue&type=script&lang=js"
export * from "./StartseiteLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports